enum ProjectStatsNavigationType {
    Introduction = 1,
    Content = 2
}

export default ProjectStatsNavigationType;
